import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-session-responses',
  templateUrl: './session-responses.component.html',
  styleUrls: ['./session-responses.component.scss'],
})
export class SessionResponsesComponent {
  @Input() taskResponses: any;

  getTypeOf(value: any) {
    return typeof value;
  }

  getFieldValue(any: any) {
    return any;
  }
}
